import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import Cookies from 'js-cookie';
import moment from "moment";
import { Calendar, EventApi } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import huLocale from '@fullcalendar/core/locales/hu';
import '~/styles/calendar.scss';

import { initCalPosts } from "./posts";
import { initCalLogEntries } from "./log_entries";
import { initCalClosedPeriods } from "./closed_periods";
import { initCalDailyLimits } from "./daily_limits";
import { initCalAirspaceTexts } from "./airspace_texts";
import { initCalCoordinators } from "./coordinators";
import { Popover } from "bootstrap";

export default class extends Controller {
  connect() {
    console.log("initCalendar");

    let popover: bootstrap.Popover | null;
    const calendarDate = (!Cookies.get('calendarDefaultDate')) ? moment() : moment(Cookies.get('calendarDefaultDate'));

    let contains_today: boolean;

    const calendar = new Calendar($('#calendar')[0], {
      plugins: [dayGridPlugin],
      themeSystem: 'bootstrap5',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: ''
      },
      initialDate: calendarDate.toDate(),
      initialView: 'dayGridMonth',
      selectable: $('#user').data('selectable'),
      selectMirror: true,
      firstDay: 1,
      allDayText: "Spec",
      height: "auto",
      eventTextColor: "black",
      locale: huLocale,
      slotLabelFormat: {
        hour: '2-digit',
        hour12: false
      },
      eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      },
      //dayMaxEventRows: 5,
      eventOrder: 'weight',
      nowIndicator: true,
      // TODO agendaEventMinHeight: 20,
      eventClick: function (info) {
        console.log(info);
        showPopover(info.el, info.event);
      },
      eventContent: function (arg) {
        //p(arg);
        const { event } = arg;
        //p(event.extendedProps);

        // Format time (e.g. "10:00", "11:30")
        //const start = event.start;
        //const end = event.end;
        //const locale = 'hu'; // or your locale

        //const formatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
        //const timeStart = start && end ? `${start.toLocaleTimeString(locale, formatOptions)} ` : '';
        //const timeEnd = start && end ? `- ${end.toLocaleTimeString(locale, formatOptions)} ` : '';

        //const startEl = document.createElement('span');
        //startEl.classList.add('fc-time', 'fc-time-start');
        //startEl.textContent = timeStart;

        //const endEl = document.createElement('span');
        //endEl.classList.add('fc-time', 'fc-time-end');
        //endEl.textContent = timeEnd;

        const titleEl = document.createElement('span');
        titleEl.classList.add('fc-title');
        titleEl.innerHTML = `<b>${event.title}</b>`;
        if (event.extendedProps.description) {
          titleEl.append("<br/>" + event.extendedProps.description);
        }

        return { domNodes: [titleEl] };
      },
      eventClassNames: function (arg) {
        const classes = [];
        if (!arg.event.extendedProps.approved) {
          classes.push('my-fc-no-approve');
        }
        return classes;
      },
      datesSet: function (view) {
        console.log(view);
        //if (view.name == 'agendaDay' && contains_today && last_view != view.name) {
        //  $('#calendar').fullCalendar('gotoDate', moment());
        //}
        contains_today = moment().isBetween(view.start, view.end);
        Cookies.set('calendarDefaultDate', view.view.currentStart.toISOString(), {
          expires: 10,
          path: '/'
        });
      },
      //dayRender : function(date, cell) {
      //	addHolidays(date);
      //	var color = getDayColor(date);
      //	if (color) {
      //		cell.css("background-color", color);
      //		idx = cell.index() + 1;
      //		$(".fc-time-grid .fc-bg table tbody tr td:nth-child(" + idx + ")").css("background-color", color);
      //	}
      //},
      //select : function(start, end, jsEvent, view) {
      //	$('#calendar').fullCalendar('unselect');
      //	newQuery = "date=" + start.local().format() + "&end=" + end.local().format() + "&user_id=" + $('#user').data('user').id;
      //	$('#modalNewEntry').modal('show');
      //
      //},
      editable: false
    });
    calendar.render();

    initCalPosts(calendar);
    initCalLogEntries(calendar);
    initCalClosedPeriods(calendar);
    initCalDailyLimits(calendar);
    initCalAirspaceTexts(calendar);
    initCalCoordinators(calendar);

    $(window).on('click', function () {
      hidePopover();
    });

    function hidePopover() {
      if (popover) { popover.dispose(); popover = null; }
    }

    function showPopover(element: Element, calEvent: EventApi) {
      hidePopover();
      var a_event = element;
      if (calEvent.extendedProps.details_url) {
        $.get(calEvent.extendedProps.details_url, function (d) {
          //console.log(d);
          popover = new Popover(a_event, {
            title: calEvent.title,
            trigger: 'manual',
            placement: 'auto',
            content: d,
            container: 'body',
            html: true
          });
          popover.show();
        });
      } else if (calEvent.url) {
        window.location.href = calEvent.url;
      }
    }

  }
}
